var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5712 0.328426C4.0091 -0.109475 4.7047 -0.109475 5.14258 0.328426C5.58048 0.766327 5.58048 1.46192 5.14258 1.8998C1.22697 5.8154 1.22697 12.1781 5.14258 16.0937C5.58048 16.5316 5.58048 17.2272 5.14258 17.6651C4.93647 17.8712 4.65308 18 4.36972 18C4.08635 18 3.803 17.897 3.59687 17.6651C-1.19453 12.8737 -1.19453 5.09407 3.57117 0.328426H3.5712Z",
    fill: "#594AD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2547 3.98638C7.6926 3.54848 8.38819 3.54848 8.82607 3.98638C9.26395 4.42429 9.26397 5.11988 8.82607 5.55776C6.94562 7.43821 6.91977 10.5295 8.82607 12.41C9.26397 12.8479 9.26397 13.5435 8.82607 13.9814C8.61996 14.1875 8.33658 14.3163 8.05322 14.3163C7.76985 14.3163 7.48649 14.2133 7.28036 13.9814C4.47254 11.2249 4.49826 6.74273 7.25467 3.98638H7.2547Z",
    fill: "#7468DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3106 1.8998C18.8727 1.4619 18.8727 0.766304 19.3106 0.328426C19.7485 -0.109475 20.4441 -0.109475 20.882 0.328426C25.6477 5.09407 25.6477 12.8737 20.882 17.6393C20.6759 17.8454 20.3925 17.9742 20.1092 17.9742C19.8258 17.9742 19.5424 17.8713 19.3363 17.6393C18.8984 17.2014 18.8984 16.5058 19.3363 16.0679C23.2262 12.1782 23.2262 5.81536 19.3106 1.8998H19.3106Z",
    fill: "#594AD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 5.55775C15.2143 5.11985 15.2143 4.42425 15.6522 3.98638C16.0901 3.5485 16.7857 3.54848 17.2236 3.98638C19.98 6.74281 19.98 11.225 17.2236 13.9813C17.0175 14.1875 16.7341 14.3163 16.4507 14.3163C16.1674 14.3163 15.884 14.2133 15.6779 13.9813C15.24 13.5434 15.24 12.8478 15.6779 12.41C17.5326 10.5295 17.5326 7.43825 15.6522 5.55775H15.6522Z",
    fill: "#7468DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3454 8.98372C10.3454 10.0223 11.1872 10.8642 12.2258 10.8642C13.2644 10.8642 14.1063 10.0223 14.1063 8.98372C14.1063 7.94512 13.2644 7.10327 12.2258 7.10327C11.1872 7.10327 10.3454 7.94512 10.3454 8.98372Z",
    fill: "#7468DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveClass);
export default __webpack_public_path__ + "static/media/liveClass.4331eaf4024d8ea5f2fa790d8ed6fde9.svg";
export { ForwardRef as ReactComponent };